// Thunks extracted from UnitPlanModule.js

import _ from "lodash";
import React from "react";
import { generateRandomId, getRelativePath } from "Utils";
import {
  getPlannerResourcesOfNodeFromCache,
  writePlannerResourcesOfNodeInCache,
  writeResourceInCache,
  getFlatUnitPlansFromCache,
  writeFlatUnitPlansInCache,
  getFlatFeedUnitPlansFromCache,
  getCustomOrderedUnitPlansFromCache,
  writeCustomOrderedUnitPlansInCache,
  writeCustomOrderedUnitPlansinLearningCourseInCache,
  getCustomOrderingUnitPlansinLearningCouseFromCache,
} from "../UnitPlanGraphqlHelpers";
import client from "lib/apolloClient/client";
import {
  geCourseGradesDetailFromCache,
  getStaffBasicDetailsFromCache,
  getGradeUnitDetailsFromCache,
  writeGradeUnitDetailsInCache,
} from "modules/CommonGraphqlHelpers";
import {
  getPlannerFieldsOfNodeQuery,
  getFlatUnitPlansQuery,
  getFlatUnitPlanFeedQuery,
  getFlatUnitPlanFeedV2Query,
} from "../UnitPlanQuery";
import { getLearningCourseUnitPlanFeedQuery } from "../LearningCourseFlow/UnitPlanLearningCourseQuery";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import {
  deleteUnitPlanMutation,
  createPlannerResourceMutation,
  updatePlannerResourceMutation,
  removePlannerResourceMutation,
  addPlannerResourceMutation,
  copyUnitPlanMutation,
  importUnitPlanMutation,
  clearUnitPlanAssessmentToolMutation,
  reorderUnitPlanMutation,
  copyUnitPlanMutationV2,
  bulkImportUnitPlanMutation,
  importInterCurriculumUnitPlanMutation,
  bulkImportUnitPlanWithTemporalMutation,
} from "../UnitPlanMutations";
import { publishResourcesMutation } from "AppComponents/OrganizationResources/modules/OrganizationResourcesMutations";
import { updateQueryParameters } from "modules/NavigationModule";
import { getCurrentPathname } from "services/NavigationService";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getUnitPlanCollaboratorsFromCache,
  getUnitPlanDetailsFromCache,
} from "IBPlanner/modules/IBGraphqlHelpers";
import {
  getFlatUnitPlansForCache,
  getUnitPlanFieldResponseFilter,
  getDisplaySetting,
  getUnitPlansFieldUIDs,
  getDisplayConfigurationSetting,
  getLearningCourseGrades,
} from "UnitPlans/modules/Utils";
import { goToRelativeRoute, openLinkInNewTab } from "modules/Services";
import { colors } from "Constants";
import moment from "moment";
import ACLStore from "lib/aclStore";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  ASC,
  UNIT_TYPE,
} from "Constants/stringConstants";
import {
  getCourseOverviewElementSetsNotCoveredCountQuery,
  getPYPYearlyInsightsQuery,
} from "UnitPlans/routes/CourseUnitPlansOverview/modules/Queries";
import {
  getUnitPlanCentralRepoInputAndFilters,
  isMapleBearLikeCommonCourse,
  mapleBearLikeOrg,
} from "Courses/modules/utils";
import { getCurriculumProgramFreeStatus } from "Platform/modules/PlatformModule/PlatformUtils";
import { getSubjectsByCurriculumMemoized } from "CourseUnitPlansOverview/modules/Module";
import { getUnitDetailsRoute } from "ToddleLibrary/modules/ToddleLibraryModule";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { getSubjectListOptionsMemoized } from "PlanningInsights/modules/Utils";
import { getOrganizationSubjectsWithSubjectGroupsFromCache } from "CommonGraphql/Organization/OrganizationGraphqlHelpers";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";
import { getUnitFlowModuleFuncs } from "UnitFlowV3/modules/UnitFlowModule";
import {
  getUnitViewType,
  isSinglePageEnabled,
} from "UnitPlans/modules/UnitViewModeUtils";
import { NEW_UNIT_VIEW } from "../../routes/UnitPlanDetails/modules/stringConstants";
import {
  getSelectedLearningCourse,
  getSelectedLearningCourseId,
} from "LearningCourse/modules/Utils";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import {
  getCourseOverviewElementSetsNotCoveredCountInLearningCourseQuery,
  getPYPYearlyInsightsInLearningCourseQuery,
} from "UnitPlans/routes/NewCourseUnitPlansOverviewV2/modules/Queries";
import { getLearningCourseSubjectsByCurriculumMemoized } from "UnitPlans/routes/NewCourseUnitPlansOverviewV2/modules/Module";
import {
  setCurrentTab,
  setCurrentUnitPlanTitle,
  updatePlannerElementSets,
  setShowLeftPane,
} from "./UnitPlanActions";
import {
  attachmentObj,
  enityEnumToLocalTypeMapping,
  fieldUids,
  CREATE_PLANNER_RESOURCE_INPUT,
  UPDATE_PLANNER_RESOURCE_INPUT,
} from "./UnitPlanUtils";
import {
  FIELD_UID_CURRICULUM_MAPPING,
  CARD_VIEW,
  TIMELINE_VIEW,
  COURSE_OVERVIEW,
  unitPlanDefaultFilters,
  defaultOrderConstants,
  validRoutes,
  CARD,
  TIMELINE,
  TABLE,
} from "./UnitPlanConstants";

import { reorderLearningCourseUnitPlanMutation } from "UnitPlans/modules/LearningCourseFlow/UnitPlanLearningCourseMutation";
import {
  getCourseFlowFeedQueryVariables,
  getCourseFlowOutlineQueryVariables,
} from "CourseFlow/modules/Utils";
import {
  getCourseFlowOutlineQuery,
  getEntireCourseFlowFeedQuery,
} from "CourseFlow/modules/CourseFlowQueries";

const UPDATE_DEBOUNCE_TIME = 0;

// Thunks
export const debounceGetPlannerFieldsOfNodeQueryFunc = () => {
  return (dispatch, getState) => {
    const focusedField = getState().pusher.focusedField;

    _.map(fieldUids, async (obj, key) => {
      const { id, type, uids, responseFilter } = obj;
      const filteredUids = _.filter(
        uids,
        uid =>
          uid !=
          _.get(focusedField[enityEnumToLocalTypeMapping[type]], "uid", "")
      );

      await client.query({
        query: getPlannerFieldsOfNodeQuery,
        variables: {
          id,
          type,
          uids: filteredUids,
          responseFilter,
        },
        fetchPolicy: "network-only",
      });
      delete fieldUids[key];
    });
  };
};

const dispatchGetPlannerFieldsOfNodeQueryFunc = dispatchFunc => {
  dispatchFunc(debounceGetPlannerFieldsOfNodeQueryFunc());
};

const debouncedGetPlannerFieldsOfNode = _.debounce(
  dispatchGetPlannerFieldsOfNodeQueryFunc,
  UPDATE_DEBOUNCE_TIME
);

export const getPlannerFieldsOfNode = ({ id, type, uids, responseFilter }) => {
  return async (dispatch, getState) => {
    const key = `${type}:${id}`;
    fieldUids[key] = {
      id,
      type,
      uids: _.union(_.get(fieldUids[key], "uids", []), uids),
      responseFilter,
    };
    debouncedGetPlannerFieldsOfNode(dispatch);
  };
};

export const goToCreateUnitPlan = ({
  courseId,
  replacePath = "courses",
  unitType,
  templateId,
}) => {
  return (dispatch, getState) => {
    let route = `courses/${courseId}/unitPlans/create`;
    if (unitType) {
      route = `${route}?unitType=${unitType}&selectedTemplateId=${templateId}`;
    }
    dispatch(
      goToRelativeRoute({
        route,
        replacePath: replacePath,
      })
    );
  };
};

export const updateGradeUnitPlanCount = ({ count = 1 }) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const state = getState();

    const isLearningCoursesEnabled = getIsLearningCoursesEnabled(state);
    const learningCourseGrade = getLearningCourseGrades(state);

    const grades = isLearningCoursesEnabled
      ? learningCourseGrade
      : _.get(state.teacher, "selected_class.selected_grades", []);

    const userId = userInfo.id;
    const isCurriculumProgramFree = getCurriculumProgramFreeStatus({ state });

    if (_.get(grades, "length", 0) >= 1) {
      const gradeId = grades[0];
      const unitGradeDetails = getGradeUnitDetailsFromCache({
        gradeId,
        userId,
        isCurriculumProgramFree,
      });
      if (!_.isEmpty(unitGradeDetails)) {
        writeGradeUnitDetailsInCache({
          id: gradeId,
          userId: userId,
          isCurriculumProgramFree,
          data: {
            ...unitGradeDetails,
            unitPlanCount: _.get(unitGradeDetails, "unitPlanCount", 0) + count,
          },
        });
      }
    }
  };
};

export const isUnitPlanEditPermission = ({ unitPlanId }) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearId = getSelectedAcademicYearId(getState());

    const collaborators = getUnitPlanCollaboratorsFromCache({
      unitPlanId,
      variables: {
        collaboratorsFilter: {
          userAcademicYearId: academicYearId,
        },
      },
    });

    const userId = userInfo.id;
    const isDevUser = userInfo.isDevUser;
    const permission = _.get(
      _.find(collaborators, collaborator => collaborator.node.id == userId),
      "permission",
      "VIEW"
    );
    let isQuickTaskEditable = false;
    //if unit plan is not attached than it will either be quick task or it is opened from community so in quick task case we are adding temporary siolution
    if (_.isEmpty(unitPlanId)) {
      isQuickTaskEditable = ACLStore.can("TeacherPortal:IsQuickTaskEditable");
    }
    return _.isEqual(permission, "EDIT") || isDevUser || isQuickTaskEditable;
  };
};

export const showNotEditableUnitPlanToast = () => {
  return (dispatch, getState) => {
    dispatch(
      setToastMsg({
        msg: `toastMsgs:no_unit_edit_permission`,
        position: "toast-top-center",
        type: "warning",
        fill: colors.yellow500,
      })
    );
  };
};

export const goToUnitPlanDetail = ({
  unitPlanId,
  mode = "view",
  type = "push",
  replacePath = "",
  isOpenInNewTab = false,
  routePostFix = "",
  isDirectCreate = false,
  openInViewMode = false,
}) => {
  return async (dispatch, getState) => {
    const activeTab = getState().login.activeTab;
    const queryVariables = dispatch(getFlatUnitPlanFeedV2QueryVariables());

    const data = getFlatFeedUnitPlansFromCache({ ...queryVariables });
    const edges = _.get(data, "node.flatUnitPlans.edges", []);
    const unitPlanNode = _.find(
      edges,
      edge => _.get(edge, "node.id") === unitPlanId
    );
    const title = _.get(unitPlanNode, "node.title.value", null);
    dispatch(setCurrentUnitPlanTitle(title));

    const currentTabArray = getCurrentPathname().split("/");
    const currentTab = currentTabArray[currentTabArray.length - 1];

    if (_.includes(validRoutes, currentTab)) {
      replacePath = currentTab;
    }
    const unitViewType = getUnitViewType();
    let route = `${unitPlanId}/${mode}${routePostFix}`;
    const state = {};
    if (isDirectCreate) {
      state.isCreateUnitPlan = true;
    }
    if (openInViewMode) {
      state.openInViewMode = true;
    }
    if (isSinglePageEnabled() && unitViewType == NEW_UNIT_VIEW) {
      route = `${unitPlanId}`;
    }
    if (activeTab == "TODDLE_LIBRARY") {
      isOpenInNewTab = false;
      route = getUnitDetailsRoute(unitPlanId, mode, routePostFix);
    }

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTab({ url: getRelativePath(route, replacePath) }));
    } else {
      dispatch(goToRelativeRoute({ route, replacePath, type, state }));
    }
  };
};

export const goToEditUnitPlanFromView = ({ step, queryParams } = {}) => {
  return (dispatch, getState) => {
    const currentTab = getState().unitPlans.currentTab;
    const stepRoute = step ? `/${step}` : ``;

    // Update here
    dispatch(
      goToRelativeRoute({
        route: `edit/${currentTab}${stepRoute}`,
        replacePath: "view",
      })
    );
    if (queryParams) {
      dispatch(updateQueryParameters({ params: queryParams }));
    }
  };
};

export const gotoAssessmentDetails = ({ id, mode = "view" }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const curriculumId = getSelectedCurriculumId(state);
    const url = `/platform/${curriculumId}/courses/assessment/${id}/${mode}`;

    dispatch(
      openLinkInNewTab({
        url,
      })
    );
  };
};

export const reorderUnitPlan = ({
  id,
  putAfterItemId,
  courseId,
  reorderedList,
}) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: reorderUnitPlanMutation,
        variables: {
          input: { id, putAfterItemId, courseId },
        },
      });
      //we will update the cache as on fetchMore we are not getting the updated data.
      const isReorderEnabled = ACLStore.can(
        "FeatureFlag:EnableUnitTimelineReordering"
      );
      const reorderUnitPlanVariables = dispatch(
        getFlatUnitPlanQueryVariables({
          orderBy: isReorderEnabled ? "COURSE_DISPLAY_SEQUENCE" : "START_DATE",
          courseId,
        })
      );

      const dataInCache = getFlatUnitPlansFromCache(reorderUnitPlanVariables);
      const shuffledUnitPlans = getFlatUnitPlansForCache({
        newEdges: reorderedList,
        edgesInCache: dataInCache.flatUnitPlans.edges,
      });
      const data = {
        node: {
          ...dataInCache,
          flatUnitPlans: {
            ...dataInCache.flatUnitPlans,
            edges: shuffledUnitPlans,
          },
        },
      };

      writeFlatUnitPlansInCache({ ...reorderUnitPlanVariables, data });
      return true;
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
      return false;
    }
  };
};

export const reorderUnitPlanV2 = ({
  id,
  putAfterItemId,
  courseId,
  reorderedList,
  orderBy,
  learningCourseId,
}) => {
  return async (dispatch, getState) => {
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

    if (isLearningCoursesEnabled) {
      await handleLearningCourseReorderUnitPlan({
        id,
        learningCourseId,
        reorderedList,
        orderBy,
        dispatch,
        putAfterItemId,
      });
    } else {
      await handleCourseReorderUnitPlan({
        id,
        courseId,
        reorderedList,
        orderBy,
        dispatch,
        putAfterItemId,
      });
    }
  };
};

const handleLearningCourseReorderUnitPlan = async ({
  id,
  learningCourseId,
  reorderedList,
  orderBy,
  dispatch,
  putAfterItemId,
}) => {
  try {
    await client.mutate({
      mutation: reorderLearningCourseUnitPlanMutation,
      variables: {
        input: { id, putAfterItemId, courseId: learningCourseId },
      },
    });

    const dataInCache = getCustomOrderingUnitPlansinLearningCouseFromCache({
      id: learningCourseId,
      first: 24,
      orderBy,
      orderByDirection: "ASC",
    });
    // update only when custom ordering data exist in cache
    if (!dataInCache?.node?.unitPlans) {
      return true;
    }

    const data = {
      node: {
        ...dataInCache.node,
        unitPlans: {
          ...dataInCache.node.unitPlans,
          edges: reorderedList,
        },
      },
    };

    writeCustomOrderedUnitPlansinLearningCourseInCache({
      id: learningCourseId,
      first: 24,
      orderBy,
      orderByDirection: "ASC",
      data,
    });
    return true;
  } catch (err) {
    dispatch(
      setToastMsg({
        msg: "toastMsgs:something_went_wrong",
        type: "warning",
        position: "toast-bottom-left",
      })
    );
    return false;
  }
};

const handleCourseReorderUnitPlan = async ({
  courseId,
  reorderedList,
  orderBy,
  id,
  putAfterItemId,
  dispatch,
}) => {
  try {
    await client.mutate({
      mutation: reorderUnitPlanMutation,
      variables: {
        input: { id, putAfterItemId, courseId },
      },
    });

    const dataInCache = getCustomOrderedUnitPlansFromCache({
      id: courseId,
      first: 24,
      orderBy,
      orderByDirection: "ASC",
    });

    const data = {
      node: {
        ...dataInCache.node,
        flatUnitPlans: {
          ...dataInCache.node.flatUnitPlans,
          edges: reorderedList,
        },
      },
    };

    writeCustomOrderedUnitPlansInCache({
      id: courseId,
      first: 24,
      orderBy,
      orderByDirection: "ASC",
      data,
    });
    return true;
  } catch (err) {
    dispatch(
      setToastMsg({
        msg: "toastMsgs:something_went_wrong",
        type: "warning",
        position: "toast-bottom-left",
      })
    );
    return false;
  }
};

export const goBackToViewUnitPlan = () => {
  return (dispatch, getState) => {
    const currentTab = getState().unitPlans.currentTab;
    // when going back from unit flow while creating something inline
    // it stays active even in view mode, reset state to fix that
    const { isUnitFlowRevampEnabled } = getUnitFlowUtils();
    if (currentTab === "unitFlow" && isUnitFlowRevampEnabled()) {
      const { setActiveContentData } = getUnitFlowModuleFuncs();
      dispatch(setActiveContentData({}));
    }

    dispatch(
      goToRelativeRoute({
        route: `view/${currentTab}`,
        type: "replace",
        replacePath: "edit",
      })
    );
  };
};

export const goUnitPlanToViewType = ({ replacePath }) => {
  return (dispatch, getState) => {
    const currentViewType = getState().unitPlans.currentViewType;
    dispatch(
      goToRelativeRoute({
        route: `${currentViewType}`,
        type: "replace",
        replacePath,
      })
    );
  };
};

// This function is used to get all the queries with variables which are to refetched in unit plan feed
// depending on card / timeline / course overview
// extracted separately as the same logic is being used while creating, deletion, importing and duplicating unit plans
export const getUnitPlanFeedRefetchQueries = () => {
  return (dispatch, getState) => {
    const state = getState();
    const courseId = state.teacher.selected_class.selected_course;
    const currentViewType = state.unitPlans.currentViewType;
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );

    const curriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    const refetchQueries = [];

    const academicYearId = getSelectedAcademicYearId(state);

    switch (currentViewType) {
      case CARD:
      case CARD_VIEW: {
        refetchQueries.push({
          query: getFlatUnitPlanFeedQuery,
          variables: dispatch(getFlatUnitPlanFeedQueryVariables()),
        });
        break;
      }
      case TIMELINE:
      case TIMELINE_VIEW: {
        const isReorderEnabled = ACLStore.can(
          "FeatureFlag:EnableUnitTimelineReordering"
        );
        refetchQueries.push({
          query: getFlatUnitPlansQuery,
          variables: dispatch(
            getFlatUnitPlanQueryVariables({
              orderBy: isReorderEnabled
                ? "COURSE_DISPLAY_SEQUENCE"
                : "START_DATE",
            })
          ),
        });
        break;
      }
      case TABLE:
      case COURSE_OVERVIEW:
        {
          const fieldUIDs = _.get(
            state,
            "courseOverview.filters.fieldUIDs",
            []
          );
          refetchQueries.push({
            query: getFlatUnitPlansQuery,
            variables: dispatch(getFlatUnitPlanQueryVariables({ fieldUIDs })),
          });

          if (_.isEqual(curriculumProgramType, CURRICULUM_TYPE_PYP)) {
            const selectedGrades = _.get(
              state,
              "teacher.selected_class.selected_grades",
              []
            );

            const subjects = getSubjectsByCurriculumMemoized({
              courseId,
              curriculumType: curriculumProgramType,
              courseGradeFilters: { academicYearId },
            });

            refetchQueries.push({
              query: getPYPYearlyInsightsQuery,
              variables: {
                id: courseId,
                filters: {
                  subjects: _.map(subjects, "id"),
                  curriculumProgramId,
                  grades: selectedGrades,
                },
              },
            });
          } else {
            refetchQueries.push({
              query: getCourseOverviewElementSetsNotCoveredCountQuery,
              variables: {
                id: courseId,
                filters: { curriculumProgramId, academicYearId },
              },
            });
          }
        }
        break;
    }

    return refetchQueries;
  };
};

export const copyUnitPlan = ({
  unitPlanId,
  title = null,
  courses,
  grades,
  unitState,
  collaborators,
  startDate = null,
  endDate = null,
  academicYears = [],
  primaryCourseId = null,
  addedExceptionalCollaborators,
  defaultStaffAccess,
  isSharedWithStudents,
  isSharedWithFamilies,
  sections,
  isImportFromToddleLibrary,
  isImportFromAnotherCurriculum,
  unitTemplateId,
  subjects,
  subjectGroups,
  mypObjectiveLevels,
  learningCourseId,
  putAfterItemId,
  unitHours,
  ownerId,
  addToTop,
}) => async (dispatch, getState) => {
  const state = getState();
  const userInfo = getUserInfo();
  const libraryUserInfo = getUserInfo({ portalType: "COMMUNITY" });
  const libraryOrgId = libraryUserInfo.org_id;
  const platformOrgId = userInfo.org_id;
  const courseId = state.teacher.selected_class.selected_course;

  grades = _.isEmpty(grades)
    ? _.get(state, "teacher.selected_class.selected_grades", [])
    : grades;
  const curriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id"
  );
  const staffId = userInfo.id;

  const isLearningCourseEnabled = getIsLearningCoursesEnabled();

  const refetchQueries = isLearningCourseEnabled
    ? dispatch(getLearningCourseUnitPlanRefetchQueries())
    : ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
    ? dispatch(getUnitPlanFeedV2RefetchQueries())
    : dispatch(getUnitPlanFeedRefetchQueries());

  const organizationId = isImportFromToddleLibrary
    ? libraryOrgId
    : platformOrgId;

  const academicYearId = getSelectedAcademicYearId(getState());

  /** MapleBear specific variables required for flat UnitPlans feed fetching logic */
  const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
    courseId,
    organizationId: platformOrgId,
    academicYearId,
  });
  /* MapleBear end */

  const isIncludeReflectionInUnitImportEnabled = ACLStore.can(
    "FeatureFlag:IncludeReflectionInUnitImport"
  );

  const isIncludeReflectionsOptionSelected = isIncludeReflectionInUnitImportEnabled
    ? _.get(state, "unitPlans.isIncludeReflectionsOptionSelected", false)
    : false;

  let input = {
    id: unitPlanId,
    copiedBy: staffId,
    title,
    startDate,
    endDate,
    courses,
    grades,
    academicYears,
    state: unitState,
    collaborators,
    sourceOrganizationId: organizationId,
    curriculumProgramId,
    primaryCourseId: isLearningCourseEnabled ? null : primaryCourseId,
    addedExceptionalCollaborators,
    defaultStaffAccess,
    isSharedWithStudents,
    isSharedWithFamilies,
    enabledSectionsV2: sections,
    ownerId,
    copyReflection: isIncludeReflectionsOptionSelected,
    addToTop,
  };

  if (isLearningCourseEnabled) {
    input = {
      ...input,
      learningCourseId,
      putAfterItemId,
    };
  }

  if (isImportFromToddleLibrary || isImportFromAnotherCurriculum) {
    input = {
      ...input,
      unitTemplateId,
      subjects,
      subjectGroups,
      mypObjectiveLevels,
      unitHours,
      copyReflection: false,
      ...(!isImportFromToddleLibrary && {
        isCrossCurriculum: isImportFromAnotherCurriculum,
      }),
    };
  }

  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  try {
    await client.mutate({
      mutation: isImportFromToddleLibrary
        ? copyUnitPlanMutationV2
        : copyUnitPlanMutation,
      variables: {
        input,
        showCollaborators: !isLearningCourseEnabled,
        centralRepoInput,
        collaboratorsFilter,
      },
      awaitRefetchQueries: true,
      refetchQueries,
    });
    dispatch(
      setToastMsg({
        msg: "toastMsgs:unit_successfully_action",
        locale_params: [
          { key: "action", value: "toastMsgs:imported", isPlainText: false },
        ],
        type: "success",
        position: "toast-bottom-left",
      })
    );
  } catch (err) {
    dispatch(
      setToastMsg({
        msg: isImportFromToddleLibrary
          ? "toastMsgs:unit_importing_failed"
          : "toastMsgs:unit_duplication_failed",
        type: "warning",
        position: "toast-bottom-left",
      })
    );
  }
};

// export const copyUnitPlan = ({
//   unitPlanId,
//   fieldValue,
//   title = null,
//   courses,
//   grades,
//   unitState,
//   collaborators,
//   startDate = null,
//   endDate = null,
//   academicYears = [],
// }) => {
//   return async (dispatch, getState) => {
//     const state = getState();
//     const staffId = state.login.userInfo.id;

//     const filters = _.get(state, "unitPlans.filters", {
//       searchText: "",
//       isShowPrivate: true,
//     });

//     const courseId = getState().teacher.selected_class.selected_course;
//     const type = "COURSE";
//     const staffData = getUnitPlanFeedFromCache({
//       id: courseId,
//       filters,
//       groupBy: "UNIT_TYPE",
//       type,
//     });

//     const edges = _.get(staffData, `unitPlans.edges`, []);

//     const edgeIndex = _.findIndex(edges, item => {
//       return item.fieldValue.toLowerCase() === fieldValue.toLowerCase();
//     });

//     const totalCount = _.get(staffData, "unitPlans.totalCount", 0);

//     try {
//       await client.mutate({
//         mutation: copyUnitPlanMutation,
//         variables: {
//           unitPlanId: unitPlanId,
//           copiedBy: staffId,
//           title: title,
//           startDate,
//           endDate,
//           courses,
//           grades,
//           academicYears,
//           state: unitState,
//           collaborators,
//           showCollaborators: true,
//         },

//         update: (
//           cache,
//           {
//             data: {
//               planner: { copyUnitPlan },
//             },
//           }
//         ) => {
//           let updatedStaffData;

//           if (edgeIndex < 0) {
//             updatedStaffData = update(staffData, {
//               unitPlans: {
//                 totalCount: { $set: totalCount + 1 },
//                 edges: {
//                   $push: [
//                     {
//                       __typename: "GroupedUnitPlanEdge",
//                       fieldValue: _.get(fieldValue, "value", ""),
//                       type: "UNIT_TYPE",
//                       node: [copyUnitPlan],
//                     },
//                   ],
//                 },
//               },
//             });
//           } else {
//             updatedStaffData = update(staffData, {
//               unitPlans: {
//                 totalCount: { $set: totalCount + 1 },
//                 edges: {
//                   [edgeIndex]: {
//                     node: {
//                       $splice: [[0, 0, copyUnitPlan]],
//                     },
//                   },
//                 },
//               },
//             });
//           }
//           writeUnitPlanFeedInCache({
//             id: courseId,
//             type,
//             filters,
//             groupBy: "UNIT_TYPE",
//             data: updatedStaffData,
//           });
//           writeUnitPlanFeedInCache({
//             id: courseId,
//             type,
//             filters: { isShowPrivate: true, searchText: "" },
//             groupBy: "UNIT_TYPE",
//             data: updatedStaffData,
//           });
//           dispatch(updateGradeUnitPlanCount({ count: 1 }));
//           dispatch(
//             setToastMsg({
//               msg: "toastMsgs:unit_successfully_action",
//               locale_params: [
//                 {
//                   key: "action",
//                   value: "toastMsgs:duplicated",
//                   isPlainText: false,
//                 },
//               ],
//               type: "success",
//               position: "toast-bottom-left",
//             })
//           );
//         },
//       });
//     } catch (err) {
//       writeUnitPlanFeedInCache({
//         id: courseId,
//         type,
//         filters,
//         groupBy: "UNIT_TYPE",
//         data: staffData,
//       });
//       writeUnitPlanFeedInCache({
//         id: courseId,
//         type,
//         filters: { isShowPrivate: true, searchText: "" },
//         groupBy: "UNIT_TYPE",
//         data: staffData,
//       });
//       dispatch(
//         setToastMsg({
//           msg: "toastMsgs:unit_duplication_failed",
//           type: "warning",
//           position: "toast-bottom-left",
//         })
//       );
//     }
//   };
// };

export const importInterCurriculumUnitPlan = params => {
  const { input, extraRefetchQueries } = params;
  return async (dispatch, getState) => {
    let { grades } = input;

    const userInfo = getUserInfo();
    const state = getState();
    const staffId = userInfo.id;

    grades = _.isEmpty(grades)
      ? _.get(state, "teacher.selected_class.selected_grades", [])
      : grades;

    // Match the branching used by `copyUnitPlan` (above): in LearningCourse-
    // enabled orgs the LC refetch helper returns the correct view-aware queries
    // (Card/Timeline/Table feed query, and the CourseFlow feed + outline in its
    // default case). 1.0 orgs continue to use the legacy refetch helpers.
    const isLearningCourseEnabled = getIsLearningCoursesEnabled();
    const defaultRefetchQueries = isLearningCourseEnabled
      ? dispatch(getLearningCourseUnitPlanRefetchQueries())
      : ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
      ? dispatch(getUnitPlanFeedV2RefetchQueries())
      : dispatch(getUnitPlanFeedRefetchQueries());

    // Callers can still append route-specific queries when the defaults
    // don't cover a view they own.
    const refetchQueries = _.isArray(extraRefetchQueries)
      ? [...defaultRefetchQueries, ...extraRefetchQueries]
      : defaultRefetchQueries;

    try {
      await client.mutate({
        mutation: importInterCurriculumUnitPlanMutation,
        variables: {
          input: {
            ...input,
            copiedBy: staffId,
            grades,
          },
          portalType: "PLANNER",
        },
        refetchQueries,
      });
      //console.log("MUTATION", { input });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:imported", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_importing_failed",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const importUnitPlan = params => {
  const { input, isFromSchoolGroupsLib, isBaseCurriculumImport } = params;
  return async (dispatch, getState) => {
    let { grades } = input;

    const userInfo = getUserInfo();
    const state = getState();
    const staffId = userInfo.id;

    grades =
      _.isEmpty(grades) && (isFromSchoolGroupsLib || isBaseCurriculumImport)
        ? _.get(state, "teacher.selected_class.selected_grades", [])
        : grades;

    const refetchQueries = ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
      ? dispatch(getUnitPlanFeedV2RefetchQueries())
      : dispatch(getUnitPlanFeedRefetchQueries());

    try {
      await client.mutate({
        mutation: importUnitPlanMutation,
        variables: {
          input: {
            ...input,
            copiedBy: staffId,
            version: "V2",
            grades,
          },
          portalType: "PLANNER",
        },
        refetchQueries,
      });
      //console.log("MUTATION", { input });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:imported", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_importing_failed",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const bulkImportUnitPlans = params => {
  return async (dispatch, getState) => {
    const {
      unitPlans,
      academicYears,
      putAfterItemId,
      addToTop = false,
      isImportFromToddleLibrary = false,
      isImportFromAnotherCurriculum = false,
    } = params;
    const state = getState();
    const currentCurriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type"
    );
    const shouldSendPrimaryCourseId =
      !_.includes([CURRICULUM_TYPE_PYP], currentCurriculumProgramType) ||
      isImportFromToddleLibrary ||
      isImportFromAnotherCurriculum;
    const userInfo = getUserInfo();
    const libraryUserInfo = getUserInfo({ portalType: "COMMUNITY" });
    const libraryOrgId = libraryUserInfo.org_id;
    const platformOrgId = userInfo.org_id;

    const organizationId = isImportFromToddleLibrary
      ? libraryOrgId
      : platformOrgId;

    const isIncludeReflectionsOptionSelected =
      state.unitPlans.isIncludeReflectionsOptionSelected;

    const isLearningCourseEnabled = getIsLearningCoursesEnabled();

    const updatedUnitPlans = _.map(unitPlans, unitPlan => ({
      ...unitPlan,
      copyReflection: isIncludeReflectionsOptionSelected,
      ...(isImportFromAnotherCurriculum && {
        sourceOrganizationId: organizationId,
      }),
      isCrossCurriculum: isImportFromAnotherCurriculum,
      ...(!isLearningCourseEnabled &&
        shouldSendPrimaryCourseId && {
          primaryCourseId: state.teacher.selected_class.selected_course,
        }),
      ...(isLearningCourseEnabled && {
        primaryCourseId: null,
      }),
    }));

    const input = {
      unitPlanDetails: updatedUnitPlans,
      primaryCourseId:
        !isLearningCourseEnabled && shouldSendPrimaryCourseId
          ? state.teacher.selected_class.selected_course
          : null,
      sourceOrganizationId: organizationId,
      curriculumProgramId: state.platform.currentCurriculumProgram.id,
      academicYears,
      addToTop,
      isToddleLibrary:
        isImportFromToddleLibrary || isImportFromAnotherCurriculum,
    };

    if (isLearningCourseEnabled) {
      input.putAfterItemId = putAfterItemId;
      input.learningCourseId = getSelectedLearningCourseId(state);
    }

    const refetchQueries = isLearningCourseEnabled
      ? dispatch(getLearningCourseUnitPlanRefetchQueries())
      : ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
      ? dispatch(getUnitPlanFeedV2RefetchQueries())
      : dispatch(getUnitPlanFeedRefetchQueries());

    const isImportUnitWithTemporalEnabled = ACLStore.can(
      "FeatureFlag:ImportUnitWithTemporal"
    );

    try {
      await client.mutate({
        mutation: isImportUnitWithTemporalEnabled
          ? bulkImportUnitPlanWithTemporalMutation
          : bulkImportUnitPlanMutation,
        variables: { input },
        refetchQueries,
        awaitRefetchQueries: true,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:imported", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_importing_failed",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const changeTab = ({ tab, type = "push" }) => {
  return (dispatch, getState) => {
    const state = getState();
    if (tab != state.unitPlans.currentTab) {
      dispatch(
        goToRelativeRoute({
          route: tab,
          type,
          replacePath: state.unitPlans.currentTab,
        })
      );
      dispatch(setCurrentTab(tab));
    }
  };
};

export const changePreviewTab = ({ unitPlanId, tab, type = "push" }) => {
  return (dispatch, getState) => {
    const state = getState();
    if (tab != state.unitPlans.currentTab) {
      dispatch(
        goToRelativeRoute({
          route: `./?unit_id=${unitPlanId}&module_id=${tab}`,
          type,
        })
      );
      dispatch(setCurrentTab(tab));
      dispatch(setShowLeftPane(false));
    }
  };
};

export const getLearningCourseUnitPlanFeedQueryVariables = ({
  fieldUIDs,
} = {}) => {
  return (dispatch, getState) => {
    const state = getState();

    const learningCourseId = getSelectedLearningCourseId(state);
    const userInfo = getUserInfo();
    const currentViewType = _.get(
      state,
      "learningCourse.currentCourseViewType",
      state?.unitPlans?.currentViewType
    );
    const curriculumProgramId = getSelectedCurriculumId(state);
    const academicYearId = getSelectedAcademicYearId(state);

    const filters = _.get(state, "unitPlans.filters", unitPlanDefaultFilters);
    const { searchText, unitType, subjects } = _.cloneDeep(filters);

    const currentCurriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    const fieldUIds = getUnitPlansFieldUIDs({
      curriculumType: currentCurriculumProgramType,
      currentViewType,
      state,
    });

    //classFilters
    const classFilters = _.get(state, "unitPlans.learningCourseFilters", {});
    const classes = _.get(classFilters, "classes", []);
    let classIds = classes === "ALL" ? [] : classes;

    if (
      _.isEmpty(classIds) &&
      _.includes([TIMELINE, TIMELINE_VIEW], currentViewType)
    ) {
      const learningCourse = getSelectedLearningCourse(state);

      const firstClass = _.first(_.get(learningCourse, "classes", []));

      classIds = _.compact([firstClass]);
    }

    const updatedFilters = {
      searchText,
      unitType: unitType == "ALL" ? [] : unitType,
      subjects: subjects == "ALL" ? [] : subjects,
      classIds,
    };

    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };
    const classFilter = {
      classFilter: {
        classIds,
      },
    };
    const displaySettings = getDisplayConfigurationSetting({
      userId: userInfo.id,
      curriculumProgramId,
      state,
    });
    const {
      sortUnitBy,
      isGroupByUnitType,
      showSubjects,
      showLE,
      showAssessments,
      showWeeksDuration,
    } = getDisplaySetting(displaySettings);
    const isMapleBearLikeOrg = mapleBearLikeOrg();

    return {
      learningCourseId,
      uids: fieldUIds || fieldUIDs,
      filters: {
        ...updatedFilters,
      },
      showCollaborators: false,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
      first: 24,
      orderByDirection: ASC,
      orderBy: isMapleBearLikeOrg ? UNIT_TYPE : sortUnitBy,
      groupBy: isMapleBearLikeOrg ? false : isGroupByUnitType,
      showSharedWithStudentsFamily: true,
      showSubjects,
      showLE,
      showAssessments,
      showWeeksDuration,
      ...(!_.isEmpty(classIds) ? classFilter : {}),
    };
  };
};

export const getFlatUnitPlanFeedV2QueryVariables = ({
  subjectGroupList = [],
  gradeList = [],
  fieldUIDs,
  courseId: paramCourseId = "",
} = {}) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;
    const courseId =
      paramCourseId || getState().teacher.selected_class.selected_course;

    const currentViewType = getState()?.unitPlans?.currentViewType;
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

    const academicYearId = getSelectedAcademicYearId(getState());
    const filters = _.get(
      getState(),
      "unitPlans.filters",
      unitPlanDefaultFilters
    );
    const filterCopy = _.cloneDeep(filters);
    const selectedSubjectIds = _.get(filterCopy, "subjects");
    const selectedGradeIds = _.get(filterCopy, "grades");
    const selectedSubjectGroupIds = _.get(filterCopy, "subjectGroups");
    const courseGradeFilters = {
      academicYearId,
    };

    const courseDetails = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters,
    });

    const userType = userInfo.user_type;
    const isUserStaff = _.isEqual(userType, "staff");
    const selectClassfilter = isLearningCoursesEnabled && !isUserStaff;

    const classFilter = {
      classFilter: {
        classIds: courseId,
      },
    };

    const currentCurriculumProgramType = _.get(
      getState(),
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    let subjectList = [];

    if (currentCurriculumProgramType == CURRICULUM_TYPE_MYP) {
      const curriculumProgramId = _.get(
        getState(),
        "platform.currentCurriculumProgram.id"
      );

      const data = getOrganizationSubjectsWithSubjectGroupsFromCache({
        id: organizationId,
        filters: {
          curriculumProgramIds: curriculumProgramId,
        },
      });

      const {
        subjectListOptionsForLabel: subjectListOptionsForLabelForMYP,
      } = getSubjectListOptionsMemoized({
        subjects: _.get(data, "subjects", []),
        curriculumType: currentCurriculumProgramType,
      });

      subjectList = subjectListOptionsForLabelForMYP;
    } else {
      const { subjectListOptionsForLabel } = getSubjectListOptionsMemoized({
        subjects: _.get(courseDetails, "subjects", []),
      });

      subjectList = subjectListOptionsForLabel;
    }

    const isAllSubjectsSelected =
      _.size(selectedSubjectIds) === _.size(subjectList);
    const isAllGradesSelected = _.size(selectedGradeIds) === _.size(gradeList);
    const isAllSubjectGroupSelected =
      _.size(selectedSubjectGroupIds) === _.size(subjectGroupList);

    const curriculumType = _.get(
      courseDetails,
      "curriculumProgram.type",
      "IB_PYP"
    );

    const fieldUIds = getUnitPlansFieldUIDs({
      curriculumType,
      currentViewType,
      state: getState(),
    });

    const isUserParent = _.isEqual(userType, "parent");

    const childId = userInfo.childID ?? null;

    const updatedFilters = {
      ...filterCopy,
      subjectGroups: isAllSubjectGroupSelected ? [] : filterCopy.subjectGroups,
      grades: isAllGradesSelected ? [] : filterCopy.grades,
      subjects: isAllSubjectsSelected ? [] : filterCopy?.subjects,
      isUnitCodeSearchable: ACLStore.can("FeatureFlag:ShowUnitCode"),
      ...(isUserParent && !_.isNull(childId) && { studentIds: [childId] }),
      ...(isLearningCoursesEnabled &&
        !isUserStaff && { isLearningCourseFeed: true }),
    };

    /** MapleBear specific variables required for flat UnitPlans feed fetching logic */
    const {
      centralRepoInput,
      centralRepoFilters,
    } = getUnitPlanCentralRepoInputAndFilters({
      courseId,
      organizationId,
      academicYearId,
    });
    /* MapleBear end */
    const courseTags = _.get(courseDetails, "tags", []);
    const isMapleBearLikeOrg = isMapleBearLikeCommonCourse({ courseTags });
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const curriculumProgramId = getSelectedCurriculumId(getState());
    const displaySettings = getDisplayConfigurationSetting({
      userId: userInfo.id,
      curriculumProgramId,
      state: getState(),
    });
    const {
      sortUnitBy,
      isGroupByUnitType,
      showSubjects,
      showLE,
      showAssessments,
      showWeeksDuration,
    } = getDisplaySetting(displaySettings);

    return {
      id: courseId,
      uids: fieldUIds || fieldUIDs,
      filters: {
        ...updatedFilters,
        ...centralRepoFilters,
        ...(isMapleBearLikeOrg ? {} : { courses: [courseId] }),
      },
      showCollaborators: !isLearningCoursesEnabled,
      centralRepoInput,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
      first: 24,
      orderByDirection: ASC,
      orderBy: isMapleBearLikeOrg ? UNIT_TYPE : sortUnitBy,
      groupBy: isMapleBearLikeOrg ? false : isGroupByUnitType,
      showSharedWithStudentsFamily: true,
      showSubjects,
      showLE,
      showAssessments,
      showWeeksDuration,
      ...(selectClassfilter ? classFilter : {}),
    };
  };
};

export const getFlatUnitPlanFeedQueryVariables = ({
  subjectGroupList = [],
  gradeList = [],
} = {}) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;
    const courseId = getState().teacher.selected_class.selected_course;
    const academicYearId = getSelectedAcademicYearId(getState());
    const filters = _.get(
      getState(),
      "unitPlans.filters",
      unitPlanDefaultFilters
    );
    const filterCopy = _.cloneDeep(filters);
    const selectedSubjectIds = _.get(filterCopy, "subjects");
    const selectedGradeIds = _.get(filterCopy, "grades");
    const selectedSubjectGroupIds = _.get(filterCopy, "subjectGroups");
    const orderConstants = _.get(
      getState(),
      "unitPlans.orderConstants",
      defaultOrderConstants
    );
    const isLearningCourseEnabled = getIsLearningCoursesEnabled();
    const currentCurriculumProgramType = _.get(
      getState(),
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    let subjectList = [];

    if (currentCurriculumProgramType == CURRICULUM_TYPE_MYP) {
      const curriculumProgramId = _.get(
        getState(),
        "platform.currentCurriculumProgram.id"
      );

      const data = getOrganizationSubjectsWithSubjectGroupsFromCache({
        id: organizationId,
        filters: {
          curriculumProgramIds: curriculumProgramId,
        },
      });

      const {
        subjectListOptionsForLabel: subjectListOptionsForLabelForMYP,
      } = getSubjectListOptionsMemoized({
        subjects: _.get(data, "subjects", []),
        curriculumType: currentCurriculumProgramType,
      });

      subjectList = subjectListOptionsForLabelForMYP;
    } else {
      const courseGradeFilters = {
        academicYearId,
      };

      const courseDetails = getCourseDetailsFromCache({
        id: courseId,
        courseGradeFilters,
      });

      const { subjectListOptionsForLabel } = getSubjectListOptionsMemoized({
        subjects: _.get(courseDetails, "subjects", []),
      });

      subjectList = subjectListOptionsForLabel;
    }

    const isAllSubjectsSelected =
      _.size(selectedSubjectIds) === _.size(subjectList);
    const isAllGradesSelected = _.size(selectedGradeIds) === _.size(gradeList);
    const isAllSubjectGroupSelected =
      _.size(selectedSubjectGroupIds) === _.size(subjectGroupList);

    const userType = userInfo?.user_type ?? null;
    const childId = userInfo?.childID ?? null;
    const isUserStaff = _.isEqual(userType, "staff");
    const isUserParent = _.isEqual(userType, "parent");

    const updatedfilterCopy = {
      ...filterCopy,
      ...(isUserParent && !_.isNull(childId) && { studentIds: [childId] }),
      ...(isLearningCourseEnabled &&
        !isUserStaff && { isLearningCourseFeed: true }),
    };
    const updatedFilters = {
      ...updatedfilterCopy,
      subjectGroups: isAllSubjectGroupSelected ? [] : filterCopy.subjectGroups,
      grades: isAllGradesSelected ? [] : filterCopy.grades,
      subjects: isAllSubjectsSelected ? [] : filterCopy?.subjects,
      isUnitCodeSearchable: ACLStore.can("FeatureFlag:ShowUnitCode"),
    };

    /** MapleBear specific variables required for flat UnitPlans feed fetching logic */
    const {
      centralRepoInput,
      centralRepoFilters,
    } = getUnitPlanCentralRepoInputAndFilters({
      courseId,
      organizationId,
      academicYearId,
    });
    /* MapleBear end */

    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    return {
      id: courseId,
      filters: { ...updatedFilters, ...centralRepoFilters },
      showCollaborators: !isLearningCourseEnabled,
      centralRepoInput,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
      ...orderConstants,
    };
  };
};

export const getFlatUnitPlanQueryVariables = ({
  fieldUIDs,
  filtersFromParent,
  first = 24,
  orderBy = "START_DATE",
  courseId,
  subjectGroupList,
  gradeList,
}) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;
    const _courseId =
      courseId ?? getState().teacher.selected_class.selected_course;
    const filters = filtersFromParent
      ? filtersFromParent
      : _.get(getState(), "unitPlans.filters", unitPlanDefaultFilters);

    const isLearningCourseEnabled = getIsLearningCoursesEnabled();
    const academicYearId = getSelectedAcademicYearId(getState());
    const courseGradeFilters = {
      academicYearId,
    };
    const courseDetails = getCourseDetailsFromCache({
      id: _courseId,
      courseGradeFilters,
    });
    const currentCurriculumProgramType = _.get(
      getState(),
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );
    let subjectList = [];
    if (currentCurriculumProgramType == CURRICULUM_TYPE_MYP) {
      const curriculumProgramId = _.get(
        getState(),
        "platform.currentCurriculumProgram.id"
      );

      const data = getOrganizationSubjectsWithSubjectGroupsFromCache({
        id: organizationId,
        filters: {
          curriculumProgramIds: curriculumProgramId,
        },
      });

      const {
        subjectListOptionsForLabel: subjectListOptionsForLabelForMYP,
      } = getSubjectListOptionsMemoized({
        subjects: _.get(data, "subjects", []),
        curriculumType: currentCurriculumProgramType,
      });
      subjectList = subjectListOptionsForLabelForMYP;
    } else {
      const { subjectListOptionsForLabel } = getSubjectListOptionsMemoized({
        subjects: _.get(courseDetails, "subjects", []),
      });
      subjectList = subjectListOptionsForLabel;
    }

    const isAllSubjectsSelected =
      _.size(subjectList) === _.size(filters?.subjects);
    const isAllGradesSelected = _.size(filters?.grades) === _.size(gradeList);
    const isAllSubjectGroupSelected =
      _.size(filters?.subjectGroups) === _.size(subjectGroupList);

    const curriculumType = _.get(
      courseDetails,
      "curriculumProgram.type",
      "IB_PYP"
    );

    const userType = userInfo?.user_type ?? null;
    const childId = userInfo?.childID ?? null;
    const isUserStaff = _.isEqual(userType, "staff");
    const isUserParent = _.isEqual(userType, "parent");
    const copyFilters = {
      ...filters,
      ...(isUserParent && !_.isNull(childId) && { studentIds: [childId] }),
      ...(isLearningCourseEnabled &&
        !isUserStaff && { isLearningCourseFeed: true }),
    };

    const updatedFilters = {
      ...copyFilters,
      subjectGroups: isAllSubjectGroupSelected ? [] : filters.subjectGroups,
      grades: isAllGradesSelected ? [] : filters.grades,
      subjects: isAllSubjectsSelected ? [] : filters?.subjects,
      isUnitCodeSearchable: ACLStore.can("FeatureFlag:ShowUnitCode"),
    };

    const exceptionalCollaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    return {
      id: _courseId,
      uids: fieldUIDs || FIELD_UID_CURRICULUM_MAPPING[curriculumType],
      first,
      orderByDirection: "ASC",
      orderBy,
      filters: {
        ...updatedFilters,
        courses: [_courseId],
      },
      exceptionalCollaboratorsFilter,
    };
  };
};

export const deleteUnitPlan = ({ unitplanId }) => {
  return async (dispatch, getState) => {
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

    const refetchQueries = isLearningCoursesEnabled
      ? dispatch(getLearningCourseUnitPlanRefetchQueries())
      : ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
      ? dispatch(getUnitPlanFeedV2RefetchQueries())
      : dispatch(getUnitPlanFeedRefetchQueries());

    try {
      await client.mutate({
        mutation: deleteUnitPlanMutation,
        variables: {
          id: unitplanId,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      dispatch(updateGradeUnitPlanCount({ count: -1 }));
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_action_successfully",
          locale_params: [
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createPlannerResource = ({ nodeId, type, portalType }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const nodeDetails = getPlannerResourcesOfNodeFromCache({ nodeId, type });
    const createResourceDetails = getState().unitPlans.resourceObject;

    const newResource = {
      ...createResourceDetails,
      usedCount: 0,
      attachments: _.map(createResourceDetails.attachments, attachment => {
        return { ...attachmentObj, ...attachment };
      }),
      id: generateRandomId(),
      createdBy: getStaffBasicDetailsFromCache(userId),
      __typename: "PlannerResource",
    };

    const attachments = _.map(createResourceDetails.attachments, attachment => {
      return _.omit(attachment, [
        "__typename",
        "id",
        "streamUrl",
        "isRead",
        "questionAttachment",
        "signedUrl",
      ]);
    });

    try {
      await client.mutate({
        mutation: createPlannerResourceMutation,
        variables: {
          input: {
            ..._.pick(createResourceDetails, CREATE_PLANNER_RESOURCE_INPUT),
            createdBy: userId,
            attachments: !_.isEmpty(attachments) ? attachments : null,
            parentId: nodeId,
            parentType: type,
          },
          portalType,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            createPlannerResource: newResource,
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { createPlannerResource },
            },
          }
        ) => {
          const resourceEdges = _.get(nodeDetails, "resources.edges", []);
          const updatedResourceEdges = [
            { node: createPlannerResource, __typename: "PlannerResourceEdge" },
            ...resourceEdges,
          ];
          const resourceConnection = {
            ...nodeDetails.resources,
            edges: updatedResourceEdges,
            totalCount: nodeDetails.resources.totalCount + 1,
          };
          const data = {
            ...nodeDetails,
            resources: resourceConnection,
          };
          setTimeout(() =>
            writePlannerResourcesOfNodeInCache({
              nodeId,
              data,
              type,
            })
          );
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:resource_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:created", isPlainText: false },
          ],
        })
      );
    } catch (error) {
      console.error(error);

      setTimeout(() =>
        writePlannerResourcesOfNodeInCache({
          nodeId,
          data: nodeDetails,
          type,
        })
      );

      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const clearUnitPlanAssessment = ({ unitPlanId }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    await client.mutate({
      mutation: clearUnitPlanAssessmentToolMutation,
      variables: {
        unitPlanId,
        updatedBy: userInfo.id,
      },
    });
  };
};

export const addPlannerResource = ({
  nodeId,
  type,
  resourceIds,
  resources,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const nodeDetails = getPlannerResourcesOfNodeFromCache({ nodeId, type });

    try {
      await client.mutate({
        mutation: addPlannerResourceMutation,
        variables: {
          resourceIds,
          createdBy: userId,
          parentId: nodeId,
          parentType: type,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            addPlannerResource: true,
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { addPlannerResource },
            },
          }
        ) => {
          if (addPlannerResource) {
            const resourceEdges = _.get(nodeDetails, "resources.edges", []);
            const newAddedResources = _.map(resources, resource => {
              return {
                node: {
                  ...resource,
                  usedCount: resource.usedCount + 1,
                },
                __typename: "PlannerResourceEdge",
              };
            });

            const updatedResourceEdges = [
              ...newAddedResources,
              ...resourceEdges,
            ];
            const resourceConnection = {
              ...nodeDetails.resources,
              edges: updatedResourceEdges,
              totalCount:
                nodeDetails.resources.totalCount + newAddedResources.length,
            };
            const data = {
              ...nodeDetails,
              resources: resourceConnection,
            };
            setTimeout(() =>
              writePlannerResourcesOfNodeInCache({
                nodeId,
                data,
                type,
              })
            );
          }
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:resource_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:added", isPlainText: false },
          ],
          type: "success",
        })
      );
    } catch (error) {
      console.error(error);
      setTimeout(() =>
        writePlannerResourcesOfNodeInCache({
          nodeId,
          data: nodeDetails,
          type,
        })
      );
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({ msg: error.graphQLErrors[0].message, notString: true })
        );
      }
    }
  };
};

export const updatePlannerResource = ({
  resourceId,
  isForced = true,
  resourceDetails,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    const updateResourceDetails = getState().unitPlans.resourceObject;
    writeResourceInCache({
      id: resourceId,
      data: {
        ...resourceDetails,
        ...updateResourceDetails,
        attachments: _.map(updateResourceDetails.attachments, attachment => {
          return { ...attachmentObj, ...attachment };
        }),
      },
    });
    const attachments = _.map(updateResourceDetails.attachments, attachment => {
      return _.omit(attachment, [
        "__typename",
        "id",
        "streamUrl",
        "isRead",
        "questionAttachment",
        "createdBy",
        "signedUrl",
      ]);
    });
    try {
      await client.mutate({
        mutation: updatePlannerResourceMutation,
        variables: {
          input: {
            ..._.pick(updateResourceDetails, UPDATE_PLANNER_RESOURCE_INPUT),
            attachments: !_.isEmpty(attachments) ? attachments : null,
            resourceId,
            updatedBy: userId,
            isForced,
          },
          portalType,
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:resource_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:updated", isPlainText: false },
          ],
          type: "success",
        })
      );
    } catch (error) {
      writeResourceInCache({
        id: resourceId,
        data: resourceDetails,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({ msg: error.graphQLErrors[0].message, notString: true })
        );
      }
    }
  };
};

export const removePlannerResource = ({
  nodeId,
  type,
  resourceId,
  isForced = false,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const nodeDetails = getPlannerResourcesOfNodeFromCache({ nodeId, type });

    try {
      const result = await client.mutate({
        mutation: removePlannerResourceMutation,
        variables: {
          resourceId,
          isForced,
          deletedBy: userId,
          parentId: nodeId,
          parentType: type,
          portalType,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            removePlannerResource: {
              warning: isForced ? null : {},
              response: true,
              __typename: "PlannerResourceRemoveResponse",
            },
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { removePlannerResource },
            },
          }
        ) => {
          if (_.isNull(removePlannerResource.warning)) {
            const resourceEdges = _.get(nodeDetails, "resources.edges", []);
            const updatedResourceEdges = _.filter(
              resourceEdges,
              resource => resource.node.id != resourceId
            );

            const resourceConnection = {
              ...nodeDetails.resources,
              edges: updatedResourceEdges,
              totalCount: nodeDetails.resources.totalCount - 1,
            };
            const data = {
              ...nodeDetails,
              resources: resourceConnection,
            };

            setTimeout(() =>
              writePlannerResourcesOfNodeInCache({
                nodeId,
                data,
                type,
              })
            );
          } else {
            setTimeout(() =>
              writePlannerResourcesOfNodeInCache({
                nodeId,
                data: nodeDetails,
                type,
              })
            );
          }
        },
      });
      const warning = result.data.planner.removePlannerResource.warning;
      if (warning) {
        return warning;
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:resource_successfully_action",
            locale_params: [
              { key: "action", value: "toastMsgs:removed", isPlainText: false },
            ],
            type: "success",
          })
        );
        return null;
      }
    } catch (error) {
      setTimeout(() =>
        writePlannerResourcesOfNodeInCache({
          nodeId,
          data: nodeDetails,
          type,
        })
      );

      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({ msg: error.graphQLErrors[0].message, notString: true })
        );
      }

      return null;
    }
  };
};

export const publishUnitPlanToCountryClasses = ({ courseIds }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const unitPlanId = _.get(getState(), "planner.unitPlanData.unitPlanId", "");
    const organizationId = userInfo.org_id;
    const selectedCourseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );

    const academicYearId = getSelectedAcademicYearId(getState());

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanData = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });

    const title = _.get(unitPlanData, "title.value", "");
    const startDate = moment(_.get(unitPlanData, "startDate", "")).format(
      "YYYY-MM-DD"
    );
    const endDate = moment(_.get(unitPlanData, "startDate", "")).format(
      "YYYY-MM-DD"
    );
    const staffId = userInfo.id;

    //this is variables that will be sent to backend
    const objToSend = {
      unitPlanId,
      copiedBy: staffId,
      title,
      startDate,
      endDate,
      unitPansToCopied: _.map(courseIds, id => {
        return {
          courseId: id,
          grades: _.map(
            _.get(geCourseGradesDetailFromCache(id), "grades", []),
            grade => grade.id
          ),
        };
      }),
    };

    try {
      const response = await client.mutate({
        mutation: publishResourcesMutation,
        variables: {
          input: {
            entityType: "UNIT_PLAN",
            metaData: objToSend,
          },
        },
      });

      const statusResponse = _.get(
        response,
        "data.integration.integrationCreateJobAndTask",
        false
      );

      if (statusResponse) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:publish_in_progress",
            type: "success",
            position: "toast-bottom-left",
          })
        );
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const setupCurriculumProgramDependencies = ({
  curriculumProgramData,
}) => {
  return (dispatch, getState) => {
    const currentCurriculumProgram = _.find(curriculumProgramData, {
      type: CURRICULUM_TYPE_PYP,
    });

    const plannerElementSets = _.get(
      currentCurriculumProgram,
      "plannerElementSets"
    );

    const plannerElementSetsByType = _.reduce(
      plannerElementSets,
      (result, plannerElementSet) => {
        result[plannerElementSet.type] = plannerElementSet;
        return result;
      },
      {}
    );

    dispatch(updatePlannerElementSets(plannerElementSetsByType));
  };
};

export const getLearningCourseUnitPlanRefetchQueries = () => {
  return (dispatch, getState) => {
    const state = getState();
    const currentViewType =
      _.get(state, "learningCourse.currentCourseViewType") ||
      _.get(state, "unitPlans.currentViewType");

    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );

    const curriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    const refetchQueries = [];
    const learningCourseId = getSelectedLearningCourseId(state);

    const learningCourseGrades = getLearningCourseGrades(state);
    const academicYearId = getSelectedAcademicYearId(state);

    const feedQueryVariables = getCourseFlowFeedQueryVariables({
      state,
    });

    const outlineQueryVariables = getCourseFlowOutlineQueryVariables({
      state,
    });

    switch (currentViewType) {
      case CARD:
      case CARD_VIEW: {
        refetchQueries.push({
          query: getLearningCourseUnitPlanFeedQuery,
          variables: dispatch(getLearningCourseUnitPlanFeedQueryVariables()),
        });
        break;
      }
      case TIMELINE:
      case TIMELINE_VIEW: {
        refetchQueries.push({
          query: getLearningCourseUnitPlanFeedQuery,
          variables: dispatch(getLearningCourseUnitPlanFeedQueryVariables()),
        });
        break;
      }
      case TABLE:
      case COURSE_OVERVIEW: {
        refetchQueries.push({
          query: getLearningCourseUnitPlanFeedQuery,
          variables: dispatch(getLearningCourseUnitPlanFeedQueryVariables()),
        });

        if (_.isEqual(curriculumProgramType, CURRICULUM_TYPE_PYP)) {
          const grades = _.map(learningCourseGrades, "id");

          const subjects = getLearningCourseSubjectsByCurriculumMemoized({
            learningCourseId,
            academicYearId,
          });

          refetchQueries.push({
            query: getPYPYearlyInsightsInLearningCourseQuery,
            variables: {
              id: learningCourseId,
              filters: {
                subjects: _.map(subjects, "id"),
                curriculumProgramId,
                grades,
              },
            },
          });
        } else {
          refetchQueries.push({
            query: getCourseOverviewElementSetsNotCoveredCountInLearningCourseQuery,
            variables: {
              id: learningCourseId,
              filters: { curriculumProgramId, academicYearId },
            },
          });
        }
        break;
      }
      default: {
        refetchQueries.push(
          {
            query: getEntireCourseFlowFeedQuery,
            variables: feedQueryVariables,
          },
          {
            query: getCourseFlowOutlineQuery,
            variables: outlineQueryVariables,
          }
        );
        break;
      }
    }

    return refetchQueries;
  };
};

// getUnitPlanFeedV2 Refetech queries as soon we will depricate getFlatUnitPlanFeed
export const getUnitPlanFeedV2RefetchQueries = () => {
  return (dispatch, getState) => {
    const state = getState();
    const courseId = state.teacher.selected_class.selected_course;
    const currentViewType = state.unitPlans.currentViewType;
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );

    const curriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    const refetchQueries = [];

    const academicYearId = getSelectedAcademicYearId(state);

    switch (currentViewType) {
      case CARD:
      case CARD_VIEW: {
        refetchQueries.push({
          query: getFlatUnitPlanFeedV2Query,
          variables: dispatch(getFlatUnitPlanFeedV2QueryVariables()),
        });
        break;
      }
      case TIMELINE:
      case TIMELINE_VIEW: {
        refetchQueries.push({
          query: getFlatUnitPlanFeedV2Query,
          variables: dispatch(getFlatUnitPlanFeedV2QueryVariables()),
        });
        break;
      }
      case TABLE:
      case COURSE_OVERVIEW:
        {
          refetchQueries.push({
            query: getFlatUnitPlanFeedV2Query,
            variables: dispatch(getFlatUnitPlanFeedV2QueryVariables()),
          });

          if (_.isEqual(curriculumProgramType, CURRICULUM_TYPE_PYP)) {
            const selectedGrades = _.get(
              state,
              "teacher.selected_class.selected_grades",
              []
            );

            const subjects = getSubjectsByCurriculumMemoized({
              courseId,
              curriculumType: curriculumProgramType,
              courseGradeFilters: { academicYearId },
            });

            refetchQueries.push({
              query: getPYPYearlyInsightsQuery,
              variables: {
                id: courseId,
                filters: {
                  subjects: _.map(subjects, "id"),
                  curriculumProgramId,
                  grades: selectedGrades,
                },
              },
            });
          } else {
            refetchQueries.push({
              query: getCourseOverviewElementSetsNotCoveredCountQuery,
              variables: {
                id: courseId,
                filters: { curriculumProgramId, academicYearId },
              },
            });
          }
        }
        break;
    }

    return refetchQueries;
  };
};
